<template>
  <NamedTabs
    :tabs="tabs"
    @change="onTabChange"
    @input="onTabInput"
  />
</template>
<script>
import documentTabs from '@/views/logics/documents/documentTabs'
import NamedTabs from '../components/namedTabs.vue'

export default {
  components: {
    NamedTabs,
  },
  mixins: [documentTabs],
  computed: {
    tabs() {
      return this.filtredtabsItem.map(tab => ({
        title: tab.title,
        icon: tab.icon,
        isActive: this.$route.name === tab.link?.name,
        hidden: tab.hidden,
      }))
    },
  },
  methods: {
    onTabChange({ index }) {
      this.tabClick(this.filtredtabsItem[index])
    },
    onTabInput(index) {
      this.tabNumber = index
    },
  },
}
</script>
